module.exports = __webpack_public_path__ + "img/500.da680992.svg";